import { Mic, Download } from 'lucide-react';
import { Button } from '../components/ui/button';
import { memo, useRef, useEffect } from 'react';

type AudioMessageProps = {
  id: string;
  audioSrc: string;
  status?: string;
};

export const AudioMessage = memo(function AudioMessage({
  id,
  audioSrc,
  status,
}: AudioMessageProps) {
  const audioRef = useRef<HTMLAudioElement>(null);
  
  // Preserve playback state
  useEffect(() => {
    if (audioRef.current) {
      const currentTime = audioRef.current.currentTime;
      audioRef.current.src = 
        audioSrc.startsWith('data:audio') || audioSrc.startsWith('blob:')
          ? audioSrc
          : audioSrc.startsWith('http')
            ? audioSrc
            : `data:audio/webm;base64,${audioSrc}`;
      audioRef.current.currentTime = currentTime;
    }
  }, [audioSrc]);

  return (
    <div className="flex items-center gap-2">
      <Button
        variant="ghost"
        size="icon"
        className="p-0"
        onClick={() => {
          if (audioRef.current) {
            audioRef.current.paused ? audioRef.current.play() : audioRef.current.pause();
          }
        }}
        title="Ouvir áudio"
      >
        <Mic
          size={28}
          className={`${status === "lida" ? "text-blue-500" : "text-gray-400"}`}
        />
      </Button>
      <audio
        ref={audioRef}
        id={`audio-${id}`}
        controls
      />
      <Button
        variant="ghost"
        size="icon"
        className="p-0 text-gray-600 dark:text-gray-300"
        asChild
        title="Baixar áudio"
      >
        <a href={audioSrc} download>
          <Download size={20} />
        </a>
      </Button>
    </div>
  );
});
